import React from 'react';
import { Flex, Spin } from 'antd';
const contentStyle = {
  padding: 50,
  background: 'rgba(0, 0, 0, 0.05)',
  borderRadius: 4,
};
const content = <div style={contentStyle} />;
const Loader = () => (
    <Flex
        gap="middle"
        vertical
        justify="center"
        align="center"
        style={{ height: "80vh" }}
    >
        <Spin tip="Loading" size="small">
            {content}
        </Spin>
    </Flex>

);
export default Loader;